import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';
import { fetchUrl } from '../../stores/actions/settings';
import MapLoading from '../../views/Dashboard/MapLoading';

export default function withAuth(ComponentToProtect) {
    return class extends Component {
        constructor() {
            super();
            this.state = {
                loading: true,
                redirect: false
            }
        }

        componentDidMount() {
            let token = localStorage.getItem('w4-token');

            fetch(`${fetchUrl}/token`, {
                method: 'GET',
                headers: { 'Authorization': `Bearer ${token}` }
            })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({ loading: false });
                    } else {
                        const error = new Error(res.error);
                        throw error;
                    }
                })
                .catch(err => {
                    this.setState({ loading: false, redirect: true });
                });
        }

        componentDidCatch(error, errorInfo) {
            // alert("Oops! Something went terribly wrong.")
            console.error("ERROR__", error, errorInfo)
        }

        render() {
            const { loading, redirect } = this.state;
            if (loading) {
                return <MapLoading testID="authLoaderContainer" />;
            }
            if (redirect) {
                return <Redirect to={{
                    pathname: "/pages/login-page",
                    state: { from: this.props.location.pathname }
                  }} />
            }
            return (
                <React.Fragment>
                    <ComponentToProtect {...this.props} />
                </React.Fragment>
            );
        }
    }
}
